import { Controller } from "@hotwired/stimulus"

// The Draft card on the Projects page (Kloepfer K8-5, Larry 2026-10-08):
// Continue is a plain link into the wizard; Discard asks first (a styled
// confirm), then drops the draft and takes the card off the page.
export default class extends Controller {
  static targets = ["modal", "confirmBtn"]
  static values = { url: String, done: String, failed: String }

  askDiscard() { this.modalTarget.classList.remove("hidden") }
  hideModal() { this.modalTarget.classList.add("hidden") }
  stopPropagation(e) { e.stopPropagation() }

  async discard() {
    this.confirmBtnTarget.disabled = true
    const res = await fetch(this.urlValue, { method: "DELETE", credentials: "same-origin",
      headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" } }).catch(() => null)
    if (!res?.ok) { this.confirmBtnTarget.disabled = false; return this._toast(this.failedValue || "Couldn't discard the draft", "alert") }
    this.hideModal()
    this.element.remove()
    this._toast(this.doneValue || "Draft discarded")
  }

  _toast(message, type = "notice") {
    const el = document.createElement("div")
    el.className = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    el.setAttribute("data-controller", "flash")
    el.setAttribute("data-flash-dismiss-after-value", "5000")
    el.textContent = message
    document.body.prepend(el)
  }
}
